import config from '../config';

export const roundInProgress = {
    startDate: '',
    userId: '',
    checkPoints: [],
    checklistItems: [],
    notes: '',
    annotations: []
}

export const initialState = () => ({
    assignations: [],
    checklistAnswers: [],
    client: '',
    config,
    currentPoint: '',
    currentRound: '', // Configuracion de la ronda actual
    drawer: false,
    inProgress: false,
    lastAnnotations: [],
    lastRound: '',
    roundInProgress, // Ronda que se esta ejecutando
    rounds: [],
    updateAvailable: true,
    user: '',
    venue: '',
    lastRounds: [],
    openRounds: [],
});
